<template>
  <div class="partMeeting-container">
    <van-sticky>
      <head-bar
          type="primary"
          :leftArrow="false"
          left-text=""
          title="会议资料库"
      />
    </van-sticky>

    <!-- 主内容区域 -->
    <div class="main">
      <!-- 紧凑描述区 -->
      <div class="compact-description">
        <div class="desc-content">
          <h3>会议资料下载</h3>
          <p>点击文档查看详情，长按可保存到本地</p>
          <div class="meta-info">
            <span><van-icon name="file-text-o" /> {{ pdfList.length }}个文档</span>
            <span><van-icon name="clock-o" /> 更新: {{ lastUpdateDate }}</span>
          </div>
        </div>
      </div>

      <!-- PDF列表 -->
      <div class="pdf-gallery">
        <div
            class="pdf-card"
            v-for="(pdf, index) in pdfList"
            :key="index"
            @click="viewPDF(pdf)"
            @touchstart="startTouch"
            @touchend="clearTouch"
        >
          <div class="cover-container">
            <img :src="pdf.cover" alt="文档封面" class="cover-image">
            <span class="pdf-tag">PDF</span>
          </div>
          <div class="card-body">
            <h4 class="title">{{ pdf.name }}</h4>
            <div class="file-info">
              <span>{{ pdf.size }}</span>
              <span>{{ pdf.date }}</span>
            </div>
            <p class="desc">{{ pdf.description }}</p>
          </div>
        </div>
      </div>

      <!-- 时间未到遮罩层 -->
      <div v-if="!isTimeReached" class="time-mask">
        <div class="time-lock-content">
          <van-icon name="clock" size="50px" color="#1976D2"/>
          <h3>敬请期待</h3>
          <p>资料库将于 {{ startTime.toLocaleString() }} 开放</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import headBar from "@/components/headBar/headBar";

export default {
  components: { headBar },
  data() {
    return {
      lastUpdateDate: "2025-09-15",
      touchTimer: null,
      startTime: new Date("2025-09-11T09:00:00"), // 设置开始时间
      isTimeReached: false, // 是否到达开始时间
      pdfList: [
        {
          name: "岳麓论坛开幕式议程",
          size: "2.4MB",
          date: "2025-09-10",
          description: "包含开幕式完整流程及嘉宾介绍",
          cover: 'https://sn202108-1305501521.cos.ap-shanghai.myqcloud.com/202508281857243880038.png',
          url: "https://example.com/path/to/pdf1.pdf"
        },
        {
          name: "AI创新生态白皮书",
          size: "5.1MB",
          date: "2025-09-08",
          description: "最新AI技术发展趋势与产业应用",
          cover: 'https://sn202108-1305501521.cos.ap-shanghai.myqcloud.com/202508281857243880038.png',
          url: "https://example.com/path/to/pdf2.pdf"
        }
      ]
    };
  },
  created() {
    this.checkTime();
    // 每分钟检查一次时间
    this.timer = setInterval(this.checkTime, 60000);
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    checkTime() {
      const now = new Date();
      this.isTimeReached = now >= this.startTime;
    },
    onClickLeft() {
      if (this.isTimeReached) {
        this.$router.push("/user/" + this.$store.state.miceInfo.miceLink);
      }
    },
    viewPDF(pdf) {
      if (this.isTimeReached && !this.touchTimer && pdf.url) {
        window.open(pdf.url, '_blank');
      }
    },
    startTouch() {
      if (this.isTimeReached) {
        this.touchTimer = setTimeout(() => {
          Toast('长按保存功能开发中');
        }, 800);
      }
    },
    clearTouch() {
      clearTimeout(this.touchTimer);
      this.touchTimer = null;
    }
  }
};
</script>

<style lang="less" scoped>
.partMeeting-container {
  height: 100vh;
  display: flex;
  flex-direction: column;
  background: url("https://sn202108-1305501521.cos.ap-shanghai.myqcloud.com/202508281859467961563.png") no-repeat;
  background-size: 100% 100%;

  .main {
    flex: 1;
    padding: 12px;
    overflow-y: auto;
    position: relative;

    /* 时间未到遮罩层 */
    .time-mask {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: rgba(255, 255, 255, 0.9);
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 100;
      backdrop-filter: blur(3px);

      .time-lock-content {
        text-align: center;
        padding: 20px;
        background: white;
        border-radius: 12px;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);

        h3 {
          font-size: 18px;
          color: #1976D2;
          margin: 10px 0;
        }

        p {
          font-size: 14px;
          color: #666;
        }
      }
    }

    /* 紧凑描述区样式 */
    .compact-description {
      background: rgba(25, 118, 210, 0.85);
      border-radius: 8px;
      padding: 12px 15px;
      margin-bottom: 15px;
      color: white;
      backdrop-filter: blur(5px);

      h3 {
        font-size: 16px;
        font-weight: 500;
        margin-bottom: 6px;
      }

      p {
        font-size: 12px;
        opacity: 0.9;
        margin-bottom: 8px;
      }

      .meta-info {
        display: flex;
        gap: 12px;
        font-size: 11px;

        span {
          display: flex;
          align-items: center;

          .van-icon {
            margin-right: 4px;
            font-size: 12px;
          }
        }
      }
    }

    /* PDF卡片列表样式 */
    .pdf-gallery {
      display: grid;
      gap: 12px;

      .pdf-card {
        background: rgba(255, 255, 255, 0.85);
        border-radius: 8px;
        overflow: hidden;
        box-shadow: 0 2px 8px rgba(0,0,0,0.08);
        transition: transform 0.2s;
        backdrop-filter: blur(5px);

        &:active {
          transform: scale(0.98);
        }

        .cover-container {
          height: 140px;
          position: relative;

          .cover-image {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }

          .pdf-tag {
            position: absolute;
            top: 8px;
            right: 8px;
            background: rgba(255,255,255,0.9);
            padding: 2px 8px;
            border-radius: 10px;
            font-size: 11px;
            color: #1976D2;
          }
        }

        .card-body {
          padding: 12px;

          .title {
            font-size: 14px;
            font-weight: 500;
            margin-bottom: 6px;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
          }

          .file-info {
            display: flex;
            justify-content: space-between;
            font-size: 11px;
            color: #888;
            margin-bottom: 6px;
          }

          .desc {
            font-size: 12px;
            color: #666;
            line-height: 1.4;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
          }
        }
      }
    }
  }
}
</style>